import { 
  SET_WORKSTATION_STEP, 
  SCAN_INITIATED, 
  SCAN_SUCCESS, 
  SCAN_FAILED,
  SCAN_REPORT_READY
} from "../types/workstationTypes";

const initialState = {
  currentStep: 1,
  password: null,
  tenantCreated: false,
  
  // Scan phase
  scanLoading: false,
  scanError: null,
  agentCode: null,
  scanCompleted: false,

  // Device info
  agentId: null,
  deviceName: null,
  executionStatus: null,
  
  // Report status
  reportLoading: false,
  reportError: null,
  reportReady: false,
  devices: [],
  recommendations: [],

  scanPolling: false,
  scanPollingError: null,
  lastScanUpdate: null
};

const workstationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WORKSTATION_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };

    case "REQUEST_SUCCEEDED":
      return {
        ...state,
        reportLoading: false,
        reportError: null,
      };

    case "REQUEST_STARTED":
      return {
        ...state,
        reportLoading: true,
        reportError: null,
      };

    case "REQUEST_FAILED":
      return {
        ...state,
        reportLoading: false,
        reportError: action.payload,
      };

    case SCAN_INITIATED:
      return {
        ...state,
        scanLoading: true,
        scanError: null,
        agentCode: action.payload,
      };

    case SCAN_SUCCESS:
      return {
        ...state,
        scanLoading: false,
        scanCompleted: true,
        agentId: action.payload.agentId,
        message: action.payload.message,
        isBackground: action.payload.isBackground || false
      };

    case SCAN_FAILED:
      return {
        ...state,
        scanLoading: false,
        scanError: action.payload,
      };

    case SCAN_REPORT_READY:
      return {
        ...state,
        reportLoading: false,
        reportReady: true,
        devices: action.payload.devices,
        recommendations: action.payload.recommendations
      };
      case 'POLL_SCAN_STARTED':
      return {
        ...state,
        scanPolling: true,
        scanPollingError: null,
        lastScanUpdate: new Date().toISOString()
      };

    case 'SCAN_COMPLETE':
      return {
        ...state,
        scanPolling: false,
        devices: action.payload.devices,
        recommendations: action.payload.recommendations
      };
    case 'POLL_SCAN_FAILED':
      return {
        ...state,
        scanPolling: false,
        scanPollingError: action.payload
      };
    case 'REPORTS_GENERATED':
  return {
    ...state,
    reports: action.payload,
    reportLoading: false
  };

    default:
      return state;
  }
};

export default workstationReducer;